define(["require", "exports", "../Models/Address", "../Models/ContactInfo"], function (require, exports, Address_1, ContactInfo_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Tenant = (function () {
        function Tenant() {
            this.CompanyName = null;
            this.BillingAddress = new Address_1.Address();
            this.HeadquarterAddress = new Address_1.Address();
            this.Contact = new ContactInfo_1.ContactInfo();
            this.ContactPerson = [];
            this.UpdatedAt = new Date();
            this.CreatedAt = new Date();
        }
        return Tenant;
    }());
    exports.Tenant = Tenant;
});
//# sourceMappingURL=Tenant.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/Tenant.js
// module id = 75
// module chunks = 0